export default __webpack_public_path__ + "static/codemymobile_website_2_blue_white_-Google-Cloud-db755a19df07c8baf2f23cab7643c711.jpg";